/* Product-page visibility and control-state repair. Native Shopify form owns cart submission. */
(() => {
  'use strict';
  const instances = new Map();
  const style = document.createElement('style');
  style.textContent = `
    product-sticky-form.ms-sticky-ready > .product-sticky-form__card {
      opacity: 0 !important; visibility: hidden !important;
      transform: translateY(15px) !important; pointer-events: none !important;
    }
    product-sticky-form.ms-sticky-ready[data-ms-sticky-visible] > .product-sticky-form__card {
      opacity: 1 !important; visibility: visible !important;
      transform: translateY(0) !important; pointer-events: auto !important;
    }
    product-sticky-form.ms-sticky-ready {
      padding-bottom: env(safe-area-inset-bottom, 0px);
    }`;
  document.head.appendChild(style);

  function mount(sticky) {
    if (instances.has(sticky)) return;
    let frame = 0;
    let observedForm = null;
    const observer = new MutationObserver(schedule);
    const resize = window.ResizeObserver ? new ResizeObserver(schedule) : null;

    function update() {
      frame = 0;
      if (!sticky.isConnected) { destroy(); return; }
      const form = document.getElementById(sticky.getAttribute('form'));
      const button = sticky.querySelector('button[type="submit"]');
      const mainButton = form && form.querySelector('button[type="submit"]');
      if (!form || !button || !mainButton) {
        sticky.removeAttribute('data-ms-sticky-visible');
        return;
      }
      if (form !== observedForm) {
        observer.disconnect();
        if (resize) resize.disconnect();
        observedForm = form;
        observer.observe(form, { subtree: true, childList: true, characterData: true,
          attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'hidden', 'value', 'aria-label'] });
        if (resize) resize.observe(form);
      }
      // Read current geometry rather than relying on stale intersection transitions.
      const rect = mainButton.getBoundingClientRect();
      const visible = rect.width > 0 && rect.height > 0 && rect.bottom <= 0;
      sticky.classList.add('ms-sticky-ready');
      sticky.toggleAttribute('data-ms-sticky-visible', visible);
      button.setAttribute('form', form.getAttribute('id'));
      const variant = form.querySelector('[name="id"]');
      button.disabled = mainButton.disabled || !variant || variant.disabled || !variant.value;
      ['aria-disabled', 'aria-busy', 'aria-label'].forEach(name => {
        if (mainButton.hasAttribute(name)) button.setAttribute(name, mainButton.getAttribute(name));
        else button.removeAttribute(name);
      });
      const label = button.querySelector('[data-sold-out]');
      const mainLabel = mainButton.querySelector('.btn-text > span') || mainButton.querySelector('.btn-text');
      if (label && mainLabel) label.textContent = mainLabel.textContent;
      const error = form.querySelector('.product-form__error-message');
      const stickyError = sticky.querySelector('.product-form__error-message');
      if (error && stickyError) {
        stickyError.textContent = error.textContent;
        stickyError.hidden = error.hidden;
      }
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    function destroy() {
      cancelAnimationFrame(frame);
      observer.disconnect();
      if (resize) resize.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('pageshow', schedule);
      document.removeEventListener('variant:change', schedule);
      instances.delete(sticky);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('variant:change', schedule);
    instances.set(sticky, { schedule, destroy });
    schedule();
  }
  function scan() {
    instances.forEach((instance, element) => {
      if (!element.isConnected) instance.destroy();
    });
    document.querySelectorAll('product-sticky-form').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', scan);
})();
